<template>
    <div class="profile-page">
        <van-cell-group>
            <van-cell title="登录账号" :value="userInfo?.username" />
            <van-cell title="用户名" :value="userInfo?.realName" />
            <van-cell title="uuid" :value="userInfo?.personUuids[0]" />
            <van-cell title="权限等级" :value="userInfo?.roles.join(',')" />
            <van-cell title="当前角色" :value="roleEnCh[userInfo?.role]" is-link @click="showRolePicker = true" />
            <van-cell title="移动端" v-if="canSwitchView">
                <template #right-icon>
                    <van-switch v-model="isMobileView" @change="handleViewModeChange" />
                </template>
            </van-cell>
        </van-cell-group>

        <!-- 添加角色选择器 -->
        <van-popup v-model="showRolePicker" position="bottom">
            <van-picker show-toolbar :columns="roleColumns" @confirm="onRoleConfirm" @cancel="showRolePicker = false" />
        </van-popup>

        <div class="logout-button">
            <van-button type="danger" block @click="handleLogout">退出登录</van-button>
        </div>
    </div>
</template>

<script>

import { logout } from "@/api/dilivery";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { setViewMode, getViewMode, setModeFlag, isMobile } from "@/utils/index";
import store from "@/store";
import { roleEnCh, roleManager } from "@/store/right";

export default {
    name: "UserInfo",
    components: { },
    data() {
        return {
            userInfo: null,
            roleEnCh: roleEnCh,
            showRolePicker: false,
            roleColumns: [],
            isMobileView: getViewMode(),
            canSwitchView: false
        }
    },
    mounted() {
        this.getUserInfo();
        this.checkViewPermission();
    },
    methods: {
        checkViewPermission() {
            const allowedRoles = ['ADMIN', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'];
            this.canSwitchView = allowedRoles.includes(this.userInfo?.role);
        },
        async handleViewModeChange(value) {
            setViewMode(value);
            if (value) {
                await this.$router.push('/Contract')
            } else {
                if (['ADMIN', 'MANAGER', 'APPROVAL_SPECIALIST'].includes(this.userInfo?.role)) {
                    await this.$router.push('/contractCheck')
                } else if (this.userInfo?.role === 'BUSINESS_COMMERCIAL') {
                    await this.$router.push('/refundInfo')
                } else if (['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES','AUDITOR'].includes(this.userInfo?.role)) {
                    await this.$router.push('/salesContract')
                } else if (['FINANCE', 'CASHIER'].includes(this.userInfo?.role)) {
                    await this.$router.push('/paymentInfo')
                } else if (['LAB', 'TECH'].includes(this.userInfo?.role)) {
                    await this.$router.push('/lexicon')
                } else if (['ANALYSE'].includes(this.userInfo?.role)) {
                    await this.$router.push('/template')
                }
            }
            
            this.$router.go(0);
        },

        // 获取用户信息
        getUserInfo() {
            this.userInfo = JSON.parse(getDataInLocalStorage('user'))
            this.userInfo.roles = this.userInfo.roles.map(role => this.roleEnCh[role]);
            this.userInfo.role = getDataInLocalStorage('role');
            // 初始化角色选择列表
            this.initRoleColumns();
        },
        initRoleColumns() {
            const roleList = JSON.parse(getDataInLocalStorage('user')).roles;
            this.roleColumns = roleList.map(role => ({
                text: roleEnCh[role],
                value: role
            }));
        },
        async onRoleConfirm(role) {
            if (role.value !== this.userInfo.role) {
                this.$store.commit('right/setRole', role.value);
                setModeFlag(role.value)
                if (!isMobile()) {
                    if (['ADMIN', 'MANAGER', 'APPROVAL_SPECIALIST'].includes(role.value)) {
                        await this.$router.push('/contractCheck')
                    } else if (role.value === 'BUSINESS_COMMERCIAL') {
                        await this.$router.push('/refundInfo')
                    } else if (['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES','AUDITOR'].includes(role.value)) {
                        await this.$router.push('/salesContract')
                    } else if (['FINANCE', 'CASHIER'].includes(role.value)) {
                        await this.$router.push('/paymentInfo')
                    } else if (['LAB', 'TECH'].includes(role.value)) {
                        await this.$router.push('/lexicon')
                    } else if (['ANALYSE'].includes(role.value)) {
                        await this.$router.push('/template')
                    }
                }
                this.$router.go(0);
            }
            
            this.showRolePicker = false;
        },
        // 登出处理
        handleLogout() {
            logout().then(res => {
                if (res.code === 200) {
                    store.commit('right/setInit')
                }
            })
            this.$router.push('/login')
        }
    },
}
</script>

<style scoped>
.profile-page {
    padding: 16px;
    background: #f7f8fa;
    min-height: 100vh;
}
.van-cell-group {
    margin-bottom: 16px;
    border-radius: 8px;
    overflow: hidden;
}
.van-cell {
    background: #fff;
}
.van-cell:not(:last-child)::after {
    left: 16px;
}
.logout-button {
    margin-top: 24px;
    padding: 0 16px;
    padding-bottom: calc(16px + constant(safe-area-inset-bottom));
    padding-bottom: calc(16px + env(safe-area-inset-bottom));
}

.van-button {
    height: 44px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 500;
}
</style>
